export default __webpack_public_path__ + "static/media/molinera-extra.15ac8d7d.png";